export enum ClockRegisterJournalClockTypeEnum {
  SCHEDULE = 'schedule',
  REST = 'rest',
}
